import React, { useState, useEffect, useRef } from "react";
import homeImage from "../assets/image/main_image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { changePw, getAllClass } from "../services/userServices";
import eyeHide from "../assets/image/eye-hide-svgrepo-com.svg";
import eyeShow from "../assets/image/eye-show-svgrepo-com.svg";

const ChangePwPage = () => {
  const [showHide, setShowHide] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [newPw, setNewPw] = useState("");
  const [error, setError] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
const tabbarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tabbarRef.current && !tabbarRef.current.contains(event.target)) {
        setShowHide(false); 
      }
    }

    if (showHide) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHide]);
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const openTabbar = () => {
    setShowHide(!showHide);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleChangePw = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password || !newPw) {
      setError("Username and your password are required");
      return;
    }

    if (password === newPw) {
      setError("New password must be different from current password");
      return;
    }

    const data = {
      email: username,
      oldPassword: password,
      newPassword: newPw,
    };

    try {
      const response = await changePw(data);
      if (response.respMsg === "success") {
        Swal.fire({
          title: "Change password Successful!",
          icon: "success",
          toast: true,
          position: "top-right",
          timer: 3000,
          showConfirmButton: false,
        });
        navigate("/home");
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <div ref={tabbarRef} className={`tabbar ${showHide ? "open" : ""}`}>
        <ul>
          <li>
            <svg
              style={{ cursor: "pointer" }}
              onClick={openTabbar}
              fill="#000000"
              width="24px"
              height="24px"
              viewBox="0 -2 28 28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="m5.216 11.998c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 2.608c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 21.389c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m9.794 0h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 9.39h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 18.781h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              </g>
            </svg>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/home")}
            >
              Home
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-license")}
            >
              License
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-logo")}
            >
              Manage logo
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/change-password")}
            >
              Change password
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${homeImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          //   alignItems: "center",
          //   justifyContent: "center",
          textAlign: "center",
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          position: "relative",
        }}
      >
        <div className="top-action">
          <svg
            style={{ cursor: "pointer" }}
            onClick={openTabbar}
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 -2 28 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="m2.61 0h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 9.39h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 18.781h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
            </g>
          </svg>
          <div
            style={{
              // position: "absolute",
              right: "10px",
              top: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={logout}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 0L3 2V14H1V16H15V14H13V2H11V14H9V0ZM6.75 9C7.16421 9 7.5 8.55229 7.5 8C7.5 7.44772 7.16421 7 6.75 7C6.33579 7 6 7.44772 6 8C6 8.55229 6.33579 9 6.75 9Z"
                  fill="#000000"
                ></path>{" "}
              </g>
            </svg>
            Logout
          </div>
        </div>
        Change password
      </div>
      <div>
        <div
          class="login-form-container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            class="login-form"
            style={{
              width: "800px",
            }}
          >
            {/* <h2 class="login-title">Change password</h2> */}
            {error && <div class="alert">{error}</div>}
            <form onSubmit={handleChangePw}>
              <div class="form-group">
                <label class="form-label">Username</label>
                <input
                  type="text"
                  class="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Old Password</label>
                <div className="pw-input">
                  <input
                    type={showOldPassword ? "text" : "password"}
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="input-group-text"
                    onClick={() => setShowOldPassword(!showOldPassword)}
                  >
                    <img
                      src={showOldPassword ? eyeHide : eyeShow}
                      alt="Toggle Password Visibility"
                    />
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">New Password</label>
                <div className="pw-input">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control"
                    value={newPw}
                    onChange={(e) => setNewPw(e.target.value)}
                    required
                  />
                  <span
                    className="input-group-text"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <img
                      src={showNewPassword ? eyeHide : eyeShow}
                      alt="Toggle Password Visibility"
                    />
                  </span>
                </div>
              </div>

              <button type="submit" class="btn-primary-cus">
                Send now
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePwPage;
